import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import '@/scss/variables.scss'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0D8134',
        secondary: '#000000',
        third: '#FFFFFF',
        accent: '#8FC461',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#F0F0F2',
        card: '#FFBA24',
        fab: '#1dc254'
      }
    }
  }
})
